import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-row-tooltip',
  template: `
    <div class="tooltip-container">
      <div [innerHTML]="htmlContent"></div>
    </div>
  `,
  styleUrl: './row-tooltip.component.scss',
})
export class RowTooltipComponent {
  @Input() htmlContent: string = '';
}
